var _mask, _g, _g2, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _text, _text2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTicketDark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 250 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "ticketNotchDark",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 4,
    width: 92,
    height: 57
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 4,
    width: 92,
    height: 57,
    rx: 9,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 32.5,
    r: 6.5,
    fill: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 92,
    cy: 32.5,
    r: 6.5,
    fill: "black"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#ticketNotchDark)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 4,
    width: 92,
    height: 57,
    rx: 9,
    fill: "#64A9FF"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(9.5 6.5) scale(0.72)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.9377 49.9172C16.1502 50.2341 16.5115 50.4031 16.894 50.4031L25.6702 50.1285C28.2202 50.1285 27.3702 50.6777 28.1564 48.2484L40.4176 11.4284C40.5451 11.0693 40.4814 10.668 40.2476 10.3511C40.0351 10.0342 39.6739 9.86523 39.2914 9.86523H29.3889C28.8789 9.86523 28.4327 10.1821 28.2627 10.668L15.7252 48.8399C15.6615 49.2201 15.7252 49.6215 15.9377 49.9172Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.2596 45.9899L49.2783 39.737C49.4058 39.3779 49.3421 38.9766 49.1083 38.6597C48.8958 38.3428 48.5346 38.1738 48.1521 38.1738H33.2984L29.4097 50.088H41.6921C44.2421 50.088 46.4733 48.4403 47.2596 45.9899Z",
    fill: "white"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 72,
    cy: 13,
    r: 1.7,
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 72,
    cy: 18,
    r: 1.7,
    fill: "white"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 72,
    cy: 23,
    r: 1.7,
    fill: "white"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 72,
    cy: 28,
    r: 1.7,
    fill: "white"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 72,
    cy: 33,
    r: 1.7,
    fill: "white"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 72,
    cy: 38,
    r: 1.7,
    fill: "white"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 72,
    cy: 43,
    r: 1.7,
    fill: "white"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 72,
    cy: 48,
    r: 1.7,
    fill: "white"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 72,
    cy: 53,
    r: 1.7,
    fill: "white"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 110,
    y: 30,
    fontFamily: "system-ui, -apple-system, 'Segoe UI', Roboto, Arial, sans-serif",
    fontSize: 21,
    fontWeight: 600,
    fill: "white"
  }, "Liefersoft")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 110,
    y: 55,
    fontFamily: "system-ui, -apple-system, 'Segoe UI', Roboto, Arial, sans-serif",
    fontSize: 21,
    fontWeight: 600,
    fill: "white"
  }, "Events")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTicketDark);
export default __webpack_public_path__ + "static/media/ticket-dark.0b37fb4dc071147d8d389e8b50f2f245.svg";
export { ForwardRef as ReactComponent };